export const filesize = (bytes: number, decimals = 2): string => {
  let value = bytes;
  const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];

  let i = 0;

  for (i; value > 1024; i++) {
    value /= 1024;
  }

  return `${parseFloat(value.toFixed(decimals))} ${units[i]}`;
};
